import { gql, useMutation } from '@apollo/client';
import { UserAuthContext } from 'contexts/UserAuthContext';
import { ERROR_TYPE, TTError, handleException } from 'models/ErrorHandling';
import { useCallback, useContext } from 'react';

const SAVE_GQL = gql`
    mutation LessonPublish($lessonID: ID!) {
        publishLesson(lessonID: $lessonID) {
            id
        }
    }
`;

type MutationVariableType = {
    lessonID: string;
};

type MutationType = {
    publishLesson: { id: string };
};

export const useLessonPublishMutation = () => {
    const { accessDenied } = useContext(UserAuthContext);
    const [fetchMutation] = useMutation<MutationType>(SAVE_GQL);

    const runMutation = useCallback(
        async (variables: MutationVariableType) => {
            try {
                const result = await fetchMutation({
                    variables,
                });

                if (!result || !result.data?.publishLesson) {
                    throw new TTError(ERROR_TYPE.UPDATE_FAILED);
                }

                return result.data.publishLesson;
            } catch (err) {
                const errMessage = handleException(err);
                if (errMessage === ERROR_TYPE.KS_ACCESS_DENIED) {
                    accessDenied(errMessage);
                }

                throw new TTError(errMessage);
            }
        },
        [fetchMutation, accessDenied],
    );

    return { runMutation };
};
